  /* eslint-disable */

import axios from 'axios';
import { extractApiError } from '@/utils/apiError';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {
  namespaced: true,
  state: {
    aptReminderData: [],
    aptReminderDetailData: [],
    settings: [],    
  },

  mutations: {
    setAptReminderData(state, payload) {
      state.aptReminderData = payload;
    },

    setAptReminderDetailData(state, payload) {
      state.aptReminderDetailData = payload;
    },

    setSettings(state, payload) {
        state.settings = payload;
    }    
  },

  actions: {
    async getAptReminderData({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading', true, {root: true});
          let response = await axios.post(`/get-apt-reminder-data`, payload, { crossdomain: true });
          commit('setAptReminderData', response.data);
          dispatch('alert/setLoading', false, {root: true});
          dispatch('alert/setLoaded', true, {root: true});
          return response.data;
      }
      catch(err) {
          console.log('Error Getting Apt Reminder Data:', err);
          dispatch('alert/setErrored', true, {root: true});
          dispatch('alert/setMessage', err, {root: true});
      }
    },

    async getAptReminderDetailData({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-apt-reminder-detail-data`, payload, { crossdomain: true });
          commit('setAptReminderDetailData', response.data);
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          return response.data;
      }
      catch(err) {
          console.log('Error Getting Apt Reminder Detail Data:', err);
          dispatch('alert/setErrored2', true, {root: true});
          dispatch('alert/setMessage2', err, {root: true});
      }
    },

    async getAptReminderSettings({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading2', true, {root: true});
            let response = await axios.post(`/get-apt-reminder-settings`, payload, { crossdomain: true });
            commit('setSettings', response.data);
            dispatch('alert/setLoading2', false, {root: true});
            dispatch('alert/setLoaded2', true, {root: true});
            return response.data;
        }
        catch(err) {
            console.log('Error Getting Apt Reminder settings:', err);
            dispatch('alert/setErrored2', true, {root: true});
            dispatch('alert/setMessage2', err, {root: true});
        }
    },

    async saveAptReminderSettings({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/save-apt-reminder-settings`, payload, { crossdomain: true });          
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          // Success message now shown via $toast in component
          return response;
      }
      catch(err) {
          console.log('Error saving Appointment Reminder Settings:', err);
          dispatch('alert/setErrored2', true, {root: true});
          // The server's own words (e.g. a refused blank inline message: { code: 'INLINE_SLOT_BLANK', message }),
          // not the axios boilerplate "Request failed with status code 400". Resolves undefined, as it always has,
          // so the screen can tell a failed save from a saved one.
          dispatch('alert/setMessage2', extractApiError(err, 'Could not save the appointment reminder settings. Please try again.'), {root: true});
      }
    },

    async pauseAppointmentReminder({commit, dispatch}, payload) {
      try {
        dispatch('alert/setLoading2', true, {root: true});
        let response = await axios.post(`/pause-apt-reminder`, payload, { crossdomain: true });          
        dispatch('alert/setLoading2', false, {root: true});
        dispatch('alert/setLoaded2', true, {root: true});          
        // Pause ALWAYS pauses. When the screen's settings contained a blank inline message the server paused anyway
        // but did not save the settings, and says so: 200 { status:'success', settingsSaved:false, warning, code }.
        // (A normal pause answers the bare string "success".) Keep that warning on screen instead of a success toast.
        const data = response && response.data;
        if (data && typeof data === 'object' && data.settingsSaved === false) {
          dispatch('alert/setErrored2', true, {root: true});
          dispatch('alert/setMessage2', data.warning || 'Appointment Reminder is paused, but your settings changes were not saved. Please save the settings again.', {root: true});
          return response;
        }
        dispatch('alert/setMessage2', 'Appointment Reminder Paused successfully!', {root: true});
        dispatch('alert/setDismissSuccessCountDown', 2, {root: true});
        return response;
      }
      catch(err) {
          console.log('Error pausing Appointment Reminder:', err);
          dispatch('alert/setErrored2', true, {root: true});
          dispatch('alert/setMessage2', err, {root: true});
      }
    }
  }
};
